export default "__VITE_ASSET__D83aKTrA__"